<template>
  <v-avatar v-if="avatarOnly" color="secondary" class="status secondary--gradient" :class="{ 'deleted': isDeleted }"
    :size="size">
    <img v-if="urlPresent" :src="avatarURL" :alt="name" />
    <span v-else class="initials"
      :class="{ undefined: isUndefined, sleeping: isSleeping, active: isActive, 'logged-out': isLoggedOut, 'deleted': isDeleted }"
      :title="name">{{ initials }}</span>
  </v-avatar>

  <v-chip v-else text-color="white" class="secondary share-chip chip-individual"
    :class="{ noButtonPadding: isButtonUsed }">
    <v-avatar class="status chip-background"
      :class="{ sleeping: isSleeping, active: isActive, 'logged-out': isLoggedOut }">
      <img v-if="urlPresent" :src="avatarURL" :alt="name" />
      <span v-else class="initials" :title="name">{{ initials }}</span>
    </v-avatar>
    <div style="width: 100%; max-width: 225px" class="text-truncate">{{ name }}</div>
    <v-btn v-if="displayAdd" small icon class="ma-0 ml-2" @click="clickedAdd">
      <v-icon color="white" class="add-remove">add_circle</v-icon>
    </v-btn>
    <v-btn v-if="displayCancel" small icon class="ma-0 ml-2" @click="clickedRemove">
      <v-icon color="white" class="add-remove">remove_circle</v-icon>
    </v-btn>
  </v-chip>
</template>

<script>
export default {
  name: "UserAvatar",
  props: {
    name: { type: String, required: true },
    userId: { type: Number },
    avatarURL: String,
    status: String,
    lastSeen: String,
    size: { type: String, default: "32px" },
    displayAdd: { type: Boolean, default: false },
    displayCancel: { type: Boolean, default: false },
    avatarOnly: { type: Boolean, default: false },
  },
  computed: {
    urlPresent: function () {
      return !!this.avatarURL
    },
    initials: function () {
      if (this.name) {
        if (this.name.length > 2) {
          const nameParts = this.name.split(" ")
          if (nameParts.length === 1) {
            return nameParts[0].substring(0, 1)
          }
          if (nameParts.length >= 2) {
            return nameParts[0].substring(0, 1) + nameParts[1].substring(0, 1)
          }
        } else {
          return this.name
        }
      }
      return ""
    },
    isUndefined: function () {
      return this.status === undefined
    },
    isSleeping: function () {
      return this.status === "sleeping"
    },
    isActive: function () {
      return this.status === "active"
    },
    isLoggedOut: function () {
      return this.status === "loggedOut"
    },
    isDeleted: function () {
      return this.status === "deleted"
    },
    isButtonUsed: function () {
      return !(this.displayCancel || this.displayAdd)
    },
  },

  methods: {
    clickedAdd() {
      this.$emit("clickedAdd", {
        user: { id: this.userId, displayName: this.name },
        type: "user",
      })
    },
    clickedRemove() {
      this.$emit("clickedRemove", {
        user: { id: this.userId, displayName: this.name },
        type: "user",
      })
    },
  },
}
</script>

<style lang="scss">
.initials {
  font-weight: 900;
}

.status {
  .sleeping {
    color: rgb(241, 150, 52);
  }

  .logged-out {
    color: rgb(149, 149, 149);
  }

  .active {
    color: rgb(54, 177, 27);
  }

  .undefined {
    color: #ffffff;
  }
  .deleted {
  color: rgba(255, 255, 255, 0.5);
}

}

.v-avatar.status.deleted {
  background-color: rgba(29, 48, 62, 0.5) !important;
  background: initial;
}

.noButtonPadding {
  padding-right: 10px;
}

.chip-background {
  background-color: rgba(255, 255, 255, 0.2);
}
</style>
